import React, { useState, useEffect } from "react";
import { OrbitLoaderComponent } from "../../utils/orbitLoader";
import { getPersonalWeeklySummary } from "../../services/apiService";
import "./EmployeeSubPage.css";

const WeeklySummary = () => {
  const [weeklyData, setWeeklyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userInfo = JSON.parse(localStorage.getItem("user") || "{}");
  const userId =
    userInfo.user_id || parseInt(localStorage.getItem("userId") || "0");

  useEffect(() => {
    const fetchWeeklySummary = async () => {
      try {
        setLoading(true);
        const data = await getPersonalWeeklySummary(userId);
        const processedData = data.map((item) => ({
          ...item,
          status: String(item.status || ""),
          total_hours: parseFloat(item.total_hours || 0),
          work_date: item.work_date || "",
        }));
        setWeeklyData(processedData);
        setLoading(false);
      } catch (error) {
        console.error("Haftalık özet çekilemedi:", error.message);
        setError(error.message);
        setLoading(false);
      }
    };
    if (userId && userId !== 0) {
      fetchWeeklySummary();
    } else {
      setError("Kullanıcı ID bulunamadı");
      setLoading(false);
    }
  }, [userId]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      return new Date(dateString).toLocaleDateString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        weekday: "short",
      });
    } catch (e) {
      return dateString;
    }
  };

  const getStatusClass = (status) => {
    const statusStr = String(status || "").toLowerCase();
    switch (statusStr) {
      case "present":
        return "present";
      case "late":
        return "late";
      default:
        return "absent";
    }
  };

  const getStatusText = (status) => {
    const statusStr = String(status || "").toLowerCase();
    switch (statusStr) {
      case "present":
        return "Var";
      case "late":
        return "Geç";
      default:
        return "Devamsız";
    }
  };

  const totalHours = weeklyData.reduce(
    (total, day) => total + parseFloat(day.total_hours || 0),
    0
  );

  if (loading) {
    return (
      <div className="loading-container">
        <OrbitLoaderComponent size="medium" showPath={true} />
        <p className="loading-text">Yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="employee-subpage">
        <div className="employee-container">
          <div className="subpage-header">
            <h2>Haftalık Özet</h2>
          </div>
          <div className="error-message">
            <i className="fas fa-exclamation-triangle"></i>
            <p>Hata: {error}</p>
            <button
              className="retry-button"
              onClick={() => window.location.reload()}
            >
              Yeniden Dene
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="employee-subpage">
      <div className="employee-container">
        <div className="subpage-header">
          <h2>Haftalık Özet</h2>
        </div>
        <div className="content-area">
          <div className="weekly-stats-grid">
            <div className="weekly-stat-card primary">
              <div className="weekly-stat-label">Haftalık Toplam</div>
              <div className="weekly-stat-value">
                {totalHours.toFixed(2)} saat
              </div>
            </div>
            <div className="weekly-stat-card success">
              <div className="weekly-stat-label">Günlük Ortalama</div>
              <div className="weekly-stat-value">
                {weeklyData.length > 0
                  ? (totalHours / weeklyData.length).toFixed(2)
                  : "0.00"}{" "}
                saat
              </div>
            </div>
          </div>
          <div className="weekly-summary-container">
            <div className="weekly-summary-header">
              <h3 className="weekly-summary-title">
                <i className="fas fa-calendar-week"></i>
                Son 7 Gün
              </h3>
            </div>
            <div className="content-area">
              {weeklyData.length > 0 ? (
                <table className="modern-table">
                  <thead>
                    <tr>
                      <th>Tarih</th>
                      <th>Çalışma Saati</th>
                      <th>Durum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {weeklyData.map((day, index) => (
                      <tr key={index}>
                        <td>{formatDate(day.work_date)}</td>
                        <td>
                          {day.total_hours ? `${day.total_hours} saat` : "-"}
                        </td>
                        <td>
                          <span
                            className={`weekly-status ${getStatusClass(
                              day.status
                            )}`}
                          >
                            {getStatusText(day.status)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="no-data">
                  <i className="fas fa-calendar-week"></i>
                  <p>Haftalık özet verisi bulunamadı.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklySummary;
